import { render, staticRenderFns } from "./courseVideo.vue?vue&type=template&id=0dabf299&scoped=true&"
import script from "./courseVideo.vue?vue&type=script&lang=js&"
export * from "./courseVideo.vue?vue&type=script&lang=js&"
import style0 from "./courseVideo.vue?vue&type=style&index=0&id=0dabf299&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dabf299",
  null
  
)

export default component.exports